import React from "react";

import AssessmentResults from "./AssessmentResults";
import type { AssessmentRecord } from "../types";

/**
 * The function `PreviousPanel` renders a panel displaying the previous and the current
 * assessments, allowing users to navigate through previous assessments.
 * @component
 * @param props - The props component.
 * @param props.onClosePanel - The function to close the panel
 * @param props.dataAssessments - The assessment data for the client
 * @returns The `PreviousPanel` component is being returned.
 */
interface PreviousPanelProps {
  onClosePanel: () => void;
  dataAssessments: AssessmentRecord[];
  clientId: string | number | null;
}

export default function PreviousPanel({
  onClosePanel,
  dataAssessments,
  clientId,
}: PreviousPanelProps) {
  return (
    <AssessmentResults
      onClosePanel={onClosePanel}
      assessmentType="vineland"
      dataAssessments={dataAssessments}
      clientId={clientId}
    />
  );
}
